import { useState } from "react";
import ArrowDown from "@assets/icons/ArrowDown";
import { ToggleSection, DividerLine, LabelText, ToggleButton } from "./toggle.styled";

interface ToggleProps {
    onClick: () => void;
    openedLabel: string;
    closedLabel: string;
}

const Toggle: React.FC<ToggleProps> = ({ onClick, openedLabel, closedLabel }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => {
        setIsOpen((prev) => !prev);
        onClick();
    };

    return (
        <ToggleSection>
            <DividerLine onClick={handleClick}>
                <ToggleButton isOpen={isOpen}>
                    <ArrowDown />
                </ToggleButton>
            </DividerLine>
            <LabelText>{isOpen ? openedLabel : closedLabel}</LabelText>
        </ToggleSection>
    );
};

export default Toggle;
